<template>
  <div>
    <nav class="navbar is-fixed-top is-info has-shadow">
      <div class="container">
        <div class="navbar-brand">
          <div class="navbar-burger is-block" :class="{ 'is-active': showMenu }" @click="showMenu = !showMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <div class="navbar-item">
            <span href="#">Plastic Collections</span>
          </div>
        </div>
      </div>

      <transition name="fade">
        <the-left-nav-menu v-if="showMenu" @close="showMenu = false" />
      </transition>
    </nav>

    <div class="viewport">
      <router-view :key="$route.name"></router-view>
    </div>
  </div>
</template>

<script>
import TheLeftNavMenu from '@/components/Menu/TheLeftNavMenu.vue'

export default {
  name: 'MasterLayout',

  data () {
    return {
      showMenu: false
    }
  },

  mounted () {
    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize)

    const html = document.getElementById('html')
    if (html) {
      html.classList.add('has-navbar-fixed-top')
    }
  },

  destroyed () {
    window.removeEventListener('resize', this.onWindowResize)

    const html = document.getElementById('html')
    if (html) {
      html.classList.remove('has-navbar-fixed-top')
    }
  },

  methods: {
    onWindowResize () {
      if (window.innerWidth >= 1666) {
        this.showMenu = true
      } else {
        this.showMenu = false
      }
    }
  },

  components: {
    TheLeftNavMenu
  }
}
</script>
